import { DatePipe, NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-news-banner',
  standalone: true,
  imports: [DatePipe, NgIf, NgFor],
  templateUrl: './news-banner.component.html',
  styleUrl: './news-banner.component.scss'
})
export class NewsBannerComponent {
  @Input() data:any; 
  @Input() showNews:boolean = false;

  constructor(private router: Router) { }

  ngOnInit(): void { 
    
  }

  goToNewsDetail(_id:any){    
    this.router.navigate(['/discovery-updates', _id]);
  }
}
